var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 10.8c2.637 0 4.8 1.948 4.8 4.32 0 2-1.54 3.679-3.6 4.165v20.728a1.2 1.2 0 1 1-2.4 0V19.285c-2.058-.486-3.6-2.166-3.6-4.164 0-2.373 2.164-4.32 4.8-4.32Z",
  fill: "#1A1A1A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 8.398c4.02 0 7.2 3.181 7.2 7.2 0 4.02-3.18 7.2-7.2 7.2-4.018 0-7.2-3.18-7.2-7.2 0-4.019 3.182-7.2 7.2-7.2Z",
  fill: "#DF3637"
})));
export default SvgPin;